/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2023-11-28 19:24:40
 */
import React, { useEffect, useState } from 'react'
import { Slider } from 'antd'
import { workProgress } from './lib'
import { FrownOutlined, SmileOutlined } from '@ant-design/icons'

interface WorkProgressProps {
  progress: number
  onChange: (value: number) => void
  disabled: boolean
}

const WorkProgress = ({ progress, onChange, disabled }: WorkProgressProps) => {
  const [preColor, setPreColor] = useState('rgba(0, 0, 0, .25)')
  const [nextColor, setNextColor] = useState('rgba(0, 0, 0, .25)')

  useEffect(() => {
    if (disabled) {
      setPreColor('rgba(0, 0, 0, .25)')
      setNextColor('rgba(0, 0, 0, .25)')
    } else {
      if (progress === 0 || progress === 1) {
        setPreColor(workProgress[progress].color)
        setNextColor('rgba(0, 0, 0, .25)')
      } else {
        setPreColor('rgba(0, 0, 0, .25)')
        setNextColor(workProgress[progress].color)
      }
    }
  }, [progress, disabled])

  return (
    <div className="process-slider-wrapper">
      <FrownOutlined style={{ color: preColor }} />
      <Slider
        min={0}
        max={3}
        disabled={disabled}
        marks={{
          0: (
            <span style={{ color: workProgress[0].color }}>
              {workProgress[0].text}
            </span>
          ),
          1: (
            <span style={{ color: workProgress[1].color }}>
              {workProgress[1].text}
            </span>
          ),
          2: (
            <span style={{ color: workProgress[2].color }}>
              {workProgress[2].text}
            </span>
          ),
          3: (
            <span style={{ color: workProgress[3].color }}>
              {workProgress[3].text}
            </span>
          )
        }}
        tooltip={{ open: false }}
        onChange={onChange}
        value={progress}
      />
      <SmileOutlined style={{ color: nextColor }} />
    </div>
  )
}

export default WorkProgress
